export const MENU_ID = 'TASK_MENU';
export const COLUMN_MENU_ID = 'COLUMN_MENU';

export const containerOrder = [
  'unassigned',
  ...Array.from({ length: 20 }, (_, i) => `camion${i + 1}`)
];

export const LEROY_FORBIDDEN_HEADERS = [
  'transporteur',
  //'poids de reprise du pdl',
  'temps de service',
  'nb transporteurs requis'
];

// ✅ cases de base : 1 par camion (modifiable)
// Tu peux en ajouter d'autres si tu veux
export const baseBoxes = ['Chargement 7h00'];

export function buildInitialColumns() {
  const cols = containerOrder.reduce(
    (acc, key) => ({
      ...acc,
      [key]: {
        name: key === 'unassigned' ? 'En attente' : `Camion ${key.replace('camion', '')}`,
        items: []
      }
    }),
    {}
  );

  containerOrder.slice(1).forEach((key) => {
    baseBoxes.forEach((label, idx) => {
      cols[key].items.push({
        id: `base-${key}-${idx}`,     // id string stable
        order_number: label,
        city: '',
        weight: 0,
        note: '',
        cornerTag: '',
        type: 'departure',            // important pour les filtres
        column_key: key,
        position: cols[key].items.length,
        isTemporary: false,
        showLoadKg: true // ✅ nouveau
      });
    });
  });

  return cols;
}
